import React, { useState } from 'react';

const MapTransactions = () => {
  const [prefixes, setPrefixes] = useState({
    journal: 'JE',
    transfer: 'TR'
  });

  const [mappings, setMappings] = useState([
    { type: 'Sell', payment: 'Sales', deposit: 'Sales' },
    { type: 'Sales Payments', payment: 'Sales', deposit: 'Sales' },
    { type: 'Purchases', payment: 'Purchases', deposit: 'Accounts Payable (A/P)' },
    { type: 'Purchase Payments', payment: 'Sales', deposit: 'Accounts Payable (A/P)' },
    { type: 'Expenses', payment: 'Purchases', deposit: 'Accounts Payable (A/P)' },
    { type: 'Expenses Lotto', payment: 'Sales', deposit: 'Uncategorised Expense' },
    { type: 'Expenses Online Lotto Paid Out', payment: 'Sales', deposit: 'Uncategorised Expense' },
    { type: 'Expenses Scratch Off Paid Out', payment: 'Sales', deposit: 'Uncategorised Expense' },
    { type: 'Expenses Online Lotto Paid Out (Alt)', payment: 'Payment account', deposit: 'Uncategorised Expense' },
  ]);

  const ACCOUNTS = ['Sales', 'Purchases', 'Accounts Payable (A/P)', 'Bank Account', 'Cash', 'Uncategorised Expense', 'Payment account'];

  return (
    <div className="table-content-card">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.25rem', flexWrap: 'wrap', gap: '1rem' }}>
        <h3 className="acc-card-title" style={{ margin: 0 }}>Map Transactions - Lefty'S Liquor</h3>
        <button className="acc-btn-primary" style={{ padding: '0.5rem 1.5rem' }}>Update</button>
      </div>

      <div style={{ display: 'flex', gap: '1rem', marginBottom: '1.5rem', flexWrap: 'wrap' }}>
        <div className="acc-form-group" style={{ flex: 1, minWidth: '200px', margin: 0 }}>
          <label style={{ display: 'block', marginBottom: '0.5rem', fontSize: '0.85rem', fontWeight: 600, color: 'var(--acc-text-main)' }}>Journal Entry Prefix:</label>
          <input 
            value={prefixes.journal} 
            onChange={e => setPrefixes(p => ({ ...p, journal: e.target.value }))}
            placeholder="e.g. JE" 
            style={{ width: '100%', padding: '0.6rem', borderRadius: 'var(--acc-radius)', border: '1px solid var(--acc-border)', outline: 'none' }}
          />
        </div>
        <div className="acc-form-group" style={{ flex: 1, minWidth: '200px', margin: 0 }}>
          <label style={{ display: 'block', marginBottom: '0.5rem', fontSize: '0.85rem', fontWeight: 600, color: 'var(--acc-text-main)' }}>Transfer Prefix:</label>
          <input 
            value={prefixes.transfer} 
            onChange={e => setPrefixes(p => ({ ...p, transfer: e.target.value }))}
            placeholder="e.g. TR" 
            style={{ width: '100%', padding: '0.6rem', borderRadius: 'var(--acc-radius)', border: '1px solid var(--acc-border)', outline: 'none' }}
          />
        </div>
      </div>

      <div className="acc-table-wrapper">
        <table className="acc-table">
          <thead>
            <tr>
              <th style={{ width: '30%' }}>Transaction Type</th>
              <th>Payment account</th>
              <th>Deposit to</th>
            </tr>
          </thead>
          <tbody>
            {mappings.map((m, i) => (
              <tr key={i}>
                <td style={{ fontWeight: 600 }}>{m.type}</td>
                <td>
                  <select 
                    value={m.payment} 
                    onChange={e => {
                      const newM = [...mappings];
                      newM[i].payment = e.target.value;
                      setMappings(newM);
                    }}
                    style={{ padding: '0.5rem', borderRadius: 'var(--acc-radius)', border: '1px solid var(--acc-border)', width: '100%', outline: 'none', background: 'var(--acc-surface)' }}
                  >
                    {ACCOUNTS.map(a => <option key={a}>{a}</option>)}
                  </select>
                </td>
                <td>
                  <select 
                    value={m.deposit} 
                    onChange={e => {
                      const newM = [...mappings];
                      newM[i].deposit = e.target.value;
                      setMappings(newM);
                    }}
                    style={{ padding: '0.5rem', borderRadius: 'var(--acc-radius)', border: '1px solid var(--acc-border)', width: '100%', outline: 'none', background: 'var(--acc-surface)' }}
                  >
                    {ACCOUNTS.map(a => <option key={a}>{a}</option>)}
                  </select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const AccountSubType = () => {
  const [items, setItems] = useState([
    { id: 1, name: 'Cash and Cash Equivalents', type: 'Asset', description: 'Money in the form of currency' },
    { id: 2, name: 'Accounts Receivable', type: 'Asset', description: 'Money owed to the business' },
    { id: 3, name: 'Accounts Payable', type: 'Liability', description: 'Money owed by the business' },
  ]);
  const [searchTerm, setSearchTerm] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [formData, setFormData] = useState({ name: '', type: 'Asset' });
  const [showExport, setShowExport] = useState(false);

  const filteredItems = items.filter(i => 
    i.name.toLowerCase().includes(searchTerm.toLowerCase()) || 
    i.type.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleOpenModal = (item = null) => {
    if (item) {
      setEditingItem(item);
      setFormData({ name: item.name, type: item.type });
    } else {
      setEditingItem(null);
      setFormData({ name: '', type: 'Asset' });
    }
    setIsModalOpen(true);
  };

  const handleSave = () => {
    if (editingItem) {
      setItems(items.map(i => i.id === editingItem.id ? { ...i, ...formData } : i));
    } else {
      setItems([...items, { id: Date.now(), ...formData, description: 'New account sub type' }]);
    }
    setIsModalOpen(false);
  };

  const handleDelete = (id) => {
    if (window.confirm('Are you sure you want to delete this account sub type?')) {
      setItems(items.filter(i => i.id !== id));
    }
  };

  const accountTypes = ['Asset', 'Expenses', 'Income', 'Equity', 'Liability'];

  return (
    <div className="table-content-card">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.25rem', flexWrap: 'wrap', gap: '1rem' }}>
        <h3 className="acc-card-title" style={{ margin: 0 }}>Account Sub Type</h3>
        
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', flexWrap: 'wrap' }}>
          {/* Search */}
          <div className="tabs-search-wrapper" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', background: 'var(--acc-surface)', padding: '0.2rem 0.5rem', borderRadius: 'var(--acc-radius)', border: '1px solid var(--acc-border)', boxShadow: 'var(--acc-shadow-sm)' }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ color: 'var(--acc-text-muted)', marginLeft: '0.5rem' }}>
              <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
            </svg>
            <input
              className="tabs-search-input"
              placeholder="Search..."
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
              style={{ border: 'none', outline: 'none', padding: '0.4rem', fontSize: '0.9rem', background: 'transparent', minWidth: '180px', color: 'var(--acc-text-main)' }}
            />
          </div>
          
          {/* Export */}
          <div style={{ position: 'relative' }}>
            <button 
              className="acc-btn-secondary" 
              onClick={() => setShowExport(!showExport)}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ opacity: 0.8 }}>
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/>
              </svg>
              Export ▾
            </button>
            {showExport && (
              <div style={{ position: 'absolute', right: 0, top: 'calc(100% + 0.5rem)', background: 'var(--acc-surface)', border: '1px solid var(--acc-border)', borderRadius: 'var(--acc-radius)', boxShadow: 'var(--acc-shadow-lg)', zIndex: 50, minWidth: '160px', overflow: 'hidden' }}>
                {['CSV', 'Excel', 'PDF', 'Print'].map(format => (
                  <div key={format} onClick={() => { alert(`Exporting ${format}...`); setShowExport(false); }} style={{ padding: '0.75rem 1rem', cursor: 'pointer', fontSize: '0.9rem', color: 'var(--acc-text-main)', borderBottom: format !== 'Print' ? '1px solid var(--acc-border)' : 'none', transition: 'background 0.2s' }} onMouseEnter={e => e.currentTarget.style.background = 'var(--acc-bg)'} onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                    Export {format}
                  </div>
                ))}
              </div>
            )}
          </div>

          <button className="acc-btn-primary" onClick={() => handleOpenModal()}>
            <span className="plus-icon" style={{ fontSize: '1.2rem', lineHeight: 1 }}>+</span> Add Sub Type
          </button>
        </div>
      </div>

      <div className="acc-table-wrapper">
        <table className="acc-table">
          <thead>
            <tr>
              <th style={{ width: '100px' }}>Action</th>
              <th>Name</th>
              <th>Account Type</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            {filteredItems.map(item => (
              <tr key={item.id}>
                <td>
                  <div style={{ display: 'flex', gap: '0.4rem' }}>
                    {/* Proper Square Action Buttons */}
                    <button 
                      onClick={() => handleOpenModal(item)} 
                      style={{ 
                        background: '#f59e0b', 
                        color: '#fff', 
                        border: 'none', 
                        width: '30px', 
                        height: '30px', 
                        borderRadius: '4px', 
                        cursor: 'pointer', 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'center',
                        boxShadow: '0 2px 4px rgba(245, 158, 11, 0.2)'
                      }} 
                      title="Edit"
                    >
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>
                    </button>
                    <button 
                      onClick={() => handleDelete(item.id)} 
                      style={{ 
                        background: '#ef4444', 
                        color: '#fff', 
                        border: 'none', 
                        width: '30px', 
                        height: '30px', 
                        borderRadius: '4px', 
                        cursor: 'pointer', 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'center',
                        boxShadow: '0 2px 4px rgba(239, 68, 68, 0.2)'
                      }} 
                      title="Delete"
                    >
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
                    </button>
                  </div>
                </td>
                <td style={{ fontWeight: 600, color: '#334155' }}>{item.name}</td>
                <td>
                  <span className="acc-badge" style={{ 
                    background: '#e0f2fe', 
                    color: '#0369a1', 
                    padding: '0.25rem 0.6rem', 
                    borderRadius: '12px', 
                    fontSize: '0.7rem', 
                    fontWeight: 700, 
                    textTransform: 'uppercase',
                    letterSpacing: '0.01em'
                  }}>
                    {item.type}
                  </span>
                </td>
                <td style={{ fontSize: '0.85rem', color: '#64748b' }}>{item.description}</td>
              </tr>
            ))}
            {filteredItems.length === 0 && (
              <tr>
                <td colSpan="4" style={{ textAlign: 'center', padding: '3rem', color: '#94a3b8' }}>
                  <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>🔍</div>
                  No matching accounts found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Add/Edit Modal */}
      {isModalOpen && (
        <div className="modal-overlay" style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15, 23, 42, 0.65)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, backdropFilter: 'blur(4px)' }}>
          <div className="modal-container" style={{ background: '#fff', borderRadius: '12px', width: '95%', maxWidth: '480px', overflow: 'hidden', boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)', animation: 'modalSlideUp 0.3s ease-out' }}>
            <div className="modal-header" style={{ padding: '1.25rem 1.5rem', borderBottom: '1px solid #f1f5f9', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#f8fafc' }}>
              <h3 style={{ margin: 0, fontSize: '1.1rem', fontWeight: 700, color: '#1e293b' }}>{editingItem ? 'Edit Account Sub Type' : 'Add Account Sub Type'}</h3>
              <button onClick={() => setIsModalOpen(false)} style={{ background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer', color: '#94a3b8', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '32px', height: '32px', borderRadius: '50%' }} title="Close">✕</button>
            </div>
            
            <div className="modal-content" style={{ padding: '2rem 1.5rem' }}>
              <div className="acc-form-group" style={{ marginBottom: '1.5rem' }}>
                <label style={{ display: 'block', marginBottom: '0.6rem', fontSize: '0.85rem', fontWeight: 700, color: '#475569' }}>Name:*</label>
                <input 
                  value={formData.name}
                  onChange={e => setFormData({ ...formData, name: e.target.value })}
                  placeholder="Name"
                  style={{ width: '100%', padding: '0.75rem', borderRadius: '8px', border: '1.5px solid #e2e8f0', fontSize: '0.9rem', outline: 'none' }}
                />
              </div>
              <div className="acc-form-group">
                <label style={{ display: 'block', marginBottom: '0.6rem', fontSize: '0.85rem', fontWeight: 700, color: '#475569' }}>Account Type:*</label>
                <select 
                  value={formData.type}
                  onChange={e => setFormData({ ...formData, type: e.target.value })}
                  style={{ width: '100%', padding: '0.75rem', borderRadius: '8px', border: '1.5px solid #e2e8f0', fontSize: '0.9rem', outline: 'none', background: '#fff' }}
                >
                  <option value="" disabled>Please Select</option>
                  {accountTypes.map(t => <option key={t} value={t}>{t}</option>)}
                </select>
              </div>
            </div>
            
            <div className="modal-footer" style={{ padding: '1.25rem 1.5rem', borderTop: '1px solid #f1f5f9', display: 'flex', justifyContent: 'center', gap: '1rem', background: '#f8fafc' }}>
              <button className="acc-btn-primary" onClick={handleSave} style={{ padding: '0.75rem 2.5rem', borderRadius: '8px', fontSize: '0.9rem', fontWeight: 700 }}>Save</button>
              <button onClick={() => setIsModalOpen(false)} style={{ padding: '0.75rem 2.5rem', background: '#fff', border: '1.5px solid #e2e8f0', borderRadius: '8px', cursor: 'pointer', fontWeight: 700, fontSize: '0.9rem', color: '#64748b' }}>Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const DetailType = () => {
  const [items, setItems] = useState([
    { id: 1, name: 'Main Checking', parentType: 'Cash and Cash Equivalents', description: 'Primary business checking account' },
    { id: 2, name: 'Petty Cash', parentType: 'Cash and Cash Equivalents', description: 'Small amount of cash on hand' },
  ]);
  const [searchTerm, setSearchTerm] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [formData, setFormData] = useState({ name: '', parentType: '', description: '' });
  const [showExport, setShowExport] = useState(false);

  // Parent options
  const parentOptions = [
    'Accounts Receivable (A/R)',
    'Current assets',
    'Cash and cash equivalents',
    'Fixed assets',
    'Non-current assets',
    'Accounts Payable (A/P)',
    'Credit Card',
    'Current liabilities',
    'Non-current liabilities',
    "Owner's Equity",
    'Income',
    'Other income',
    'Cost of sales',
    'Expenses',
    'Other Expense'
  ];

  const filteredItems = items.filter(i => {
    const term = searchTerm || '';
    return (
      (i.name || '').toLowerCase().includes(term.toLowerCase()) || 
      (i.parentType || '').toLowerCase().includes(term.toLowerCase())
    );
  });

  const handleOpenModal = (item = null) => {
    if (item) {
      setEditingItem(item);
      setFormData({ name: item.name, parentType: item.parentType, description: item.description || '' });
    } else {
      setEditingItem(null);
      setFormData({ name: '', parentType: '', description: '' });
    }
    setIsModalOpen(true);
  };

  const handleSave = () => {
    if (editingItem) {
      setItems(items.map(i => i.id === editingItem.id ? { ...i, ...formData } : i));
    } else {
      setItems([...items, { id: Date.now(), ...formData, description: 'New detail type' }]);
    }
    setIsModalOpen(false);
  };

  const handleDelete = (id) => {
    if (window.confirm('Are you sure you want to delete this detail type?')) {
      setItems(items.filter(i => i.id !== id));
    }
  };

  return (
    <div className="table-content-card">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.25rem', flexWrap: 'wrap', gap: '1rem' }}>
        <h3 className="acc-card-title" style={{ margin: 0 }}>Detail Type</h3>
        
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', flexWrap: 'wrap' }}>
          {/* Search */}
          <div className="tabs-search-wrapper" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', background: 'var(--acc-surface)', padding: '0.2rem 0.5rem', borderRadius: 'var(--acc-radius)', border: '1px solid var(--acc-border)', boxShadow: 'var(--acc-shadow-sm)' }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ color: 'var(--acc-text-muted)', marginLeft: '0.5rem' }}>
              <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
            </svg>
            <input
              className="tabs-search-input"
              placeholder="Search..."
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
              style={{ border: 'none', outline: 'none', padding: '0.4rem', fontSize: '0.9rem', background: 'transparent', minWidth: '180px', color: 'var(--acc-text-main)' }}
            />
          </div>
          
          {/* Export */}
          <div style={{ position: 'relative' }}>
            <button 
              className="acc-btn-secondary" 
              onClick={() => setShowExport(!showExport)}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ opacity: 0.8 }}>
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/>
              </svg>
              Export ▾
            </button>
            {showExport && (
              <div style={{ position: 'absolute', right: 0, top: 'calc(100% + 0.5rem)', background: 'var(--acc-surface)', border: '1px solid var(--acc-border)', borderRadius: 'var(--acc-radius)', boxShadow: 'var(--acc-shadow-lg)', zIndex: 50, minWidth: '160px', overflow: 'hidden' }}>
                {['CSV', 'Excel', 'PDF', 'Print'].map(format => (
                  <div key={format} onClick={() => { alert(`Exporting ${format}...`); setShowExport(false); }} style={{ padding: '0.75rem 1rem', cursor: 'pointer', fontSize: '0.9rem', color: 'var(--acc-text-main)', borderBottom: format !== 'Print' ? '1px solid var(--acc-border)' : 'none', transition: 'background 0.2s' }} onMouseEnter={e => e.currentTarget.style.background = 'var(--acc-bg)'} onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                    Export {format}
                  </div>
                ))}
              </div>
            )}
          </div>

          <button className="acc-btn-primary" onClick={() => handleOpenModal()}>
            <span className="plus-icon" style={{ fontSize: '1.2rem', lineHeight: 1 }}>+</span> Add Detail Type
          </button>
        </div>
      </div>

      <div className="acc-table-wrapper">
        <table className="acc-table">
          <thead>
            <tr>
              <th style={{ width: '100px' }}>Action</th>
              <th>Name</th>
              <th>Parent Account Sub Type</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            {filteredItems.map(item => (
              <tr key={item.id}>
                <td>
                  <div style={{ display: 'flex', gap: '0.4rem' }}>
                    <button 
                      onClick={() => handleOpenModal(item)} 
                      style={{ background: '#f59e0b', color: '#fff', border: 'none', width: '30px', height: '30px', borderRadius: '4px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 2px 4px rgba(245, 158, 11, 0.2)' }} 
                      title="Edit"
                    >
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>
                    </button>
                    <button 
                      onClick={() => handleDelete(item.id)} 
                      style={{ background: '#ef4444', color: '#fff', border: 'none', width: '30px', height: '30px', borderRadius: '4px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 2px 4px rgba(239, 68, 68, 0.2)' }} 
                      title="Delete"
                    >
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
                    </button>
                  </div>
                </td>
                <td style={{ fontWeight: 600, color: '#334155' }}>{item.name}</td>
                <td>
                  <span className="acc-badge" style={{ background: '#f0fdf4', color: '#166534', padding: '0.25rem 0.6rem', borderRadius: '12px', fontSize: '0.7rem', fontWeight: 700, textTransform: 'uppercase' }}>
                    {item.parentType}
                  </span>
                </td>
                <td style={{ fontSize: '0.85rem', color: '#64748b' }}>{item.description}</td>
              </tr>
            ))}
            {filteredItems.length === 0 && (
              <tr>
                <td colSpan="4" style={{ textAlign: 'center', padding: '3rem', color: '#94a3b8' }}>
                  <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>🔍</div>
                  No matching detail types found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Add/Edit Modal */}
      {isModalOpen && (
        <div className="modal-overlay" style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15, 23, 42, 0.65)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, backdropFilter: 'blur(4px)' }}>
          <div className="modal-container" style={{ background: '#fff', borderRadius: '12px', width: '95%', maxWidth: '480px', overflow: 'hidden', boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)', animation: 'modalSlideUp 0.3s ease-out' }}>
            <div className="modal-header" style={{ padding: '1.25rem 1.5rem', borderBottom: '1px solid #f1f5f9', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#f8fafc' }}>
              <h3 style={{ margin: 0, fontSize: '1.1rem', fontWeight: 700, color: '#1e293b' }}>{editingItem ? 'Edit Detail Type' : 'Add Detail Type'}</h3>
              <button onClick={() => setIsModalOpen(false)} style={{ background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer', color: '#94a3b8', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '32px', height: '32px', borderRadius: '50%' }} title="Close">✕</button>
            </div>
            
            <div className="modal-content" style={{ padding: '2rem 1.5rem' }}>
              <div className="acc-form-group" style={{ marginBottom: '1.25rem' }}>
                <label style={{ display: 'block', marginBottom: '0.6rem', fontSize: '0.85rem', fontWeight: 700, color: '#1e293b' }}>Name:*</label>
                <input 
                  value={formData.name}
                  onChange={e => setFormData({ ...formData, name: e.target.value })}
                  placeholder="Name"
                  style={{ width: '100%', padding: '0.75rem', borderRadius: '4px', border: '1px solid #cbd5e1', fontSize: '0.9rem', outline: 'none' }}
                />
              </div>
              <div className="acc-form-group" style={{ marginBottom: '1.25rem' }}>
                <label style={{ display: 'block', marginBottom: '0.6rem', fontSize: '0.85rem', fontWeight: 700, color: '#1e293b' }}>Parent Type:*</label>
                <select 
                  value={formData.parentType}
                  onChange={e => setFormData({ ...formData, parentType: e.target.value })}
                  style={{ width: '100%', padding: '0.75rem', borderRadius: '4px', border: '1px solid #cbd5e1', fontSize: '0.9rem', outline: 'none', background: '#fff', color: '#334155' }}
                >
                  <option value="" disabled>Please Select</option>
                  {parentOptions.map(t => <option key={t} value={t}>{t}</option>)}
                </select>
              </div>
              <div className="acc-form-group">
                <label style={{ display: 'block', marginBottom: '0.6rem', fontSize: '0.85rem', fontWeight: 700, color: '#1e293b' }}>Description:</label>
                <textarea 
                  value={formData.description}
                  onChange={e => setFormData({ ...formData, description: e.target.value })}
                  placeholder="Description"
                  style={{ width: '100%', padding: '0.75rem', borderRadius: '4px', border: '1px solid #cbd5e1', fontSize: '0.9rem', outline: 'none', resize: 'vertical', minHeight: '80px', fontFamily: 'inherit' }}
                />
              </div>
            </div>
            
            <div className="modal-footer" style={{ padding: '1.25rem 1.5rem', display: 'flex', justifyContent: 'center', gap: '0.75rem', background: '#fff' }}>
              <button onClick={handleSave} style={{ background: '#4c1d95', color: '#fff', padding: '0.6rem 2rem', border: 'none', borderRadius: '6px', fontSize: '0.875rem', fontWeight: 600, cursor: 'pointer' }}>Save</button>
              <button onClick={() => setIsModalOpen(false)} style={{ background: '#334155', color: '#fff', padding: '0.6rem 2rem', border: 'none', borderRadius: '6px', fontSize: '0.875rem', fontWeight: 600, cursor: 'pointer' }}>Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const AccountingSettings = () => {
  const [activeSubTab, setActiveSubTab] = useState('map');

  const subTabs = [
    { id: 'map', label: 'Accounting Settings / Map Transactions' },
    { id: 'subType', label: 'Account Sub Type' },
    { id: 'detailType', label: 'Detail Type' },
  ];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
      {/* Subtab Navigation Pill Bar */}
      <div style={{ display: 'flex', gap: '0.5rem', overflowX: 'auto', paddingBottom: '0.25rem' }}>
        {subTabs.map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveSubTab(tab.id)}
            style={{
              padding: '0.6rem 1.25rem',
              borderRadius: '999px',
              fontSize: '0.875rem',
              fontWeight: 600,
              cursor: 'pointer',
              whiteSpace: 'nowrap',
              border: 'none',
              background: activeSubTab === tab.id ? 'var(--acc-primary)' : 'var(--acc-surface)',
              color: activeSubTab === tab.id ? '#fff' : 'var(--acc-text-main)',
              boxShadow: activeSubTab === tab.id ? '0 4px 12px rgba(99, 102, 241, 0.3)' : 'var(--acc-shadow-sm)',
              transition: 'all 0.2s ease'
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>
      
      <div>
        {activeSubTab === 'map' && <MapTransactions />}
        {activeSubTab === 'subType' && <AccountSubType />}
        {activeSubTab === 'detailType' && <DetailType />}
      </div>
    </div>
  );
};

export default AccountingSettings;

